import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Leaf } from "@phosphor-icons/react";

const REGIONS = ["all", "Kerala", "Malabar", "South India", "Pan-India"];

export default function Nutrition() {
  const [foods, setFoods] = useState([]);
  const [region, setRegion] = useState("all");

  useEffect(() => { api.get("/nutrition/foods", { params: { region } }).then((r) => setFoods(r.data)); }, [region]);

  return (
    <div className="p-6 md:p-12 pb-24 md:pb-12">
      <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="overline text-terracotta">Rooted in Kerala food culture</div>
          <h1 className="font-heritage text-5xl text-ayurveda mt-1">Nutrition</h1>
          <p className="text-charcoal/70 mt-2 max-w-lg">Evidence-aware, culturally rooted guidance. Individual microbiomes vary — we won't pretend to know yours without a test.</p>
        </div>
        <Select value={region} onValueChange={setRegion}>
          <SelectTrigger className="w-56 bg-white" data-testid="nutrition-region">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {REGIONS.map((r) => <SelectItem key={r} value={r}>{r === "all" ? "All regions" : r}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {foods.map((f) => (
          <Card key={f.id} className="border-black/5 bg-white overflow-hidden hover:-translate-y-1 transition-transform duration-300" data-testid={`food-${f.id}`}>
            <div className="h-40 relative">
              <img src={f.photo_url} alt={f.name} className="w-full h-full object-cover" />
              <Badge className="absolute top-3 left-3 bg-ayurveda text-bone">{f.category}</Badge>
              <Badge variant="outline" className="absolute top-3 right-3 bg-white/90 border-none">{f.region}</Badge>
            </div>
            <CardContent className="p-5 space-y-3">
              <div className="flex items-center gap-2">
                <Leaf size={18} weight="duotone" className="text-terracotta" />
                <div className="font-clinical text-lg text-ayurveda">{f.name}</div>
              </div>
              <div>
                <div className="overline text-charcoal/50 text-[10px] mb-1">Benefits</div>
                <div className="flex flex-wrap gap-1">
                  {f.benefits.map((b) => <Badge key={b} variant="outline" className="text-[10px]">{b}</Badge>)}
                </div>
              </div>
              <div>
                <div className="overline text-charcoal/50 text-[10px] mb-1">Preparation</div>
                <p className="text-xs text-charcoal/70 leading-relaxed">{f.preparation}</p>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
